import Vue from 'vue'
import ElementUI from 'element-ui'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'
import VueSession from 'vue-session'
import routes from './routes'
import store from './store'
import vueConfig from 'vue-config'
import configs from './configs'
import axios from 'axios'
import './filters'
import VueQuillEditor from 'vue-quill-editor'
import requests from './requests'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// Resource logic
Vue.use(VueQuillEditor)
Vue.use(Resource)
Vue.http.options.emulateJSON = true
Vue.use(VueSession, {
  persist: true
})
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(vueConfig, configs.configs)
Vue.prototype.requests = requests

// Import top level component
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
//  for element 1.9.9 below
// import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/index.css'

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
  /*
    检查用户是否登录
    未登录则跳转到登录页
  */
  if (!store.getters.isAuthenticated && to.name !== 'login') {
    next('/login')
  } else {
    axios.defaults.withCredentials = true
    // axios.defaults.headers['JSESSIONID'] = `${store.state.sessionId}`
    axios.interceptors.response.use(function (config) {
      // Do something before request is sent
      console.log(config)
      if (config.data.result === 'fail' && (config.data.message && config.data.message.indexOf('请登录后') !== -1)) {
        store.dispatch('LOGOUT')
        next('/login')
      }
      return config
    }, function (error) {
      // router.app.$pt.showErrorMessage(error, '请求接口出错', router.app)
      return Promise.reject(error)
    })
    next()
  }
  // 设置页面 title
  // document.title = to.meta.title
})

// Check local storage to handle refreshes
if (window.localStorage) {
  if (store.state.token !== window.localStorage.getItem('token')) {
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

// Some middleware to help us ensure the user is authenticated.

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
})

require('bootstrap')
// require('admin-lte')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')
require('../node_modules/admin-lte/dist/js/app.js')
// require('../node_modules/admin-lte/dist/js/demo.js')




// WEBPACK FOOTER //
// ./src/main.js